import { combineReducers } from "redux";
import tokenReducer from "./tokenReducers";

export default combineReducers({
    tokenReducer,
});
